

const session = {
  set: (keyValue: string, value: string): void => {
    return sessionStorage.setItem(keyValue, value);
  },

  get: (keyValue: string): string | null => {
    return sessionStorage.getItem(keyValue);
  },
};

const local = {
  set: (keyValue: string, value: string): void => {
    return localStorage.setItem(keyValue, value);
  },

  get: (keyValue: string): string | null => {
    return localStorage.getItem(keyValue);
  },
};

const genGetSetKeyLocal = (key: string) => ({
  get: (): string => local.get(key) ?? '',
  set: (value: string): void => local.set(key, value),
});

const genGetSetKeySession = (key: string) => ({
  get: (): string => session.get(key) ?? '',
  set: (value: string): void => session.set(key, value),
});

const storage = {
  get: session.get,
  set: session.set,
  genGetSetKeyLocal,
  genGetSetKeySession,
  tickets_filter: genGetSetKeyLocal('tickets_filter'),
};

export default storage;
